<template>
  <tr class="product-selections__row product-selections__row--finish">
    <td class="product-selections__cell product-selections__cell--item product-selections__cell--finish">{{ accessory.title }}:</td>
    <td class="product-selections__cell product-selections__cell--qty" colspan="1">
      <input type="number" class="input--qty" @change="onAccessoryQtyChange()" v-model="qty" />
    </td>
    <td class="product-selections__cell product-selections__cell--pricenovat">£{{ qtyPrice }}</td>
    <td class="product-selections__cell product-selections__cell--priceplusvat">£{{ qtyPricePlusVat }}</td>
    <td class="product-selections__cell product-selections__cell--remove"><span @click="$emit('accessoryRemoved', accessory)" class="remove">×</span></td>
  </tr>
</template>

<script>
  export default {
    props: ['accessory'],
    data() {
      return {
        qty: 1,
        qtyPrice: 0,
        qtyPricePlusVat: 0
      }
    },
    beforeMount() {
      this.qty = this.accessory.qty ?? 1;
      this.qtyPrice = this.accessoryQtyPrice;
      this.qtyPricePlusVat = this.accessoryQtyPricePlusVat;
    },
    methods: {
      onAccessoryRemoved: function() {
        this.accessory.qty = 0;

        this.$emit('accessoryRemoved', this.accessory);
      },
      onAccessoryQtyChange: function() {
        if (this.qty < 1) {
          this.$emit('accessoryRemoved', this.accessory);
        } else {
          this.qtyPrice = this.accessoryQtyPrice;
          this.qtyPricePlusVat = this.accessoryQtyPricePlusVat;

          this.accessory.qty = parseInt(this.qty);
          this.accessory.qtyPrice = this.qtyPrice;
          this.accessory.qtyPricePlusVat = this.qtyPricePlusVat;

          this.$emit('accessoryQtyChanged', this.accessory);
        }
      }
    },
    computed: {
      accessoryQtyPrice: function() {
        return (parseInt(this.accessory.price) * parseInt(this.qty)).toFixed(2);
      },
      accessoryQtyPricePlusVat: function () {
        return (parseInt(this.accessory.pricePlusVat) * parseInt(this.qty)).toFixed(2);
      }
    }
  }
</script>

<style scoped>
  td {
		padding: 9px 18px;
		text-align: left;
		border-bottom: 1px solid #eee;
	}

  input {
    width: 100%;
    max-width: 9.375rem;
  }

  .remove {
		cursor: pointer;
	}
</style>